var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.appStarted)?_c('div',{staticClass:"layout-wrapper"},[_c(_vm.selectLayout,{tag:"component"})],1):_vm._e(),(_vm.activeLoader && !_vm.appStarted)?_c('AppLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }